// src/data/patientDashboardMockData.js

// Mock data for patient dashboard statistics
export const dashboardStatsMockData = {
  upcoming: 3,
  upcoming_trend: 1,
  upcoming_trend_text: "+1 from last month",
  active_prescriptions: 2,
  recent_consultations: 5,
  total_expenses: 1250,
  total_expenses_trend: -5,
  total_expenses_trend_text: "-5% from last month",
  health_score: 85,
  health_score_trend: 2,
  health_score_trend_text: "+2 from last month",
  next_appointment: {
    id: 1,
    doctor_name: "Dr. Arvind Kumar",
    date: "2024-09-15",
    time: "10:00 AM",
    type: "Follow-up"
  }
};

// Mock data for appointment history
export const appointmentHistoryMockData = [
  { month: "Jan", appointments: 2 },
  { month: "Feb", appointments: 1 },
  { month: "Mar", appointments: 3 },
  { month: "Apr", appointments: 2 },
  { month: "May", appointments: 4 },
  { month: "Jun", appointments: 3 }
];

// Mock data for health summary
export const healthSummaryMockData = [
  { name: "Mental Health", value: 75 },
  { name: "Physical Health", value: 85 },
  { name: "Sleep Quality", value: 70 },
  { name: "Stress Level", value: 65 }
];

// Mock data for recent appointments
export const recentAppointmentsMockData = [
  {
    id: 1,
    doctor_name: "Dr. Arvind Kumar",
    date: "2024-08-10",
    time: "10:00 AM",
    type: "Initial Consultation",
    status: "Completed"
  },
  {
    id: 2,
    doctor_name: "Dr. Suresh Choudhury",
    date: "2024-08-15",
    time: "02:30 PM",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 3,
    doctor_name: "Dr. Dipankar Deka",
    date: "2024-09-05",
    time: "11:00 AM",
    type: "Consultation",
    status: "Scheduled"
  }
];

// Mock data for upcoming appointments
export const upcomingAppointmentsMockData = [
  {
    id: 4,
    doctor_name: "Dr. Arvind Kumar",
    date: "2024-09-15",
    time: "10:00 AM",
    type: "Follow-up",
    status: "Confirmed"
  },
  {
    id: 5,
    doctor_name: "Dr. Suresh Choudhury",
    date: "2024-09-20",
    time: "03:00 PM",
    type: "Consultation",
    status: "Pending"
  }
];

// Mock data for prescriptions
export const prescriptionsMockData = [
  {
    id: 1,
    medication: "Sertraline 50mg",
    dosage: "1 tablet daily",
    start_date: "2024-08-10",
    end_date: "2024-09-10",
    status: "Active"
  },
  {
    id: 2,
    medication: "Lorazepam 1mg",
    dosage: "1 tablet as needed",
    start_date: "2024-08-15",
    end_date: "2024-09-15",
    status: "Active"
  }
];

// Mock data for health metrics
export const healthMetricsMockData = {
  mood_trend: [
    { date: "2024-08-01", value: 7 },
    { date: "2024-08-05", value: 6 },
    { date: "2024-08-10", value: 8 },
    { date: "2024-08-15", value: 7 },
    { date: "2024-08-20", value: 9 },
    { date: "2024-08-25", value: 8 },
    { date: "2024-08-30", value: 9 }
  ],
  sleep_hours: [
    { date: "2024-08-01", value: 7.5 },
    { date: "2024-08-05", value: 6.8 },
    { date: "2024-08-10", value: 7.2 },
    { date: "2024-08-15", value: 7.0 },
    { date: "2024-08-20", value: 7.8 },
    { date: "2024-08-25", value: 7.5 },
    { date: "2024-08-30", value: 8.0 }
  ],
  stress_level: [
    { date: "2024-08-01", value: 5 },
    { date: "2024-08-05", value: 4 },
    { date: "2024-08-10", value: 3 },
    { date: "2024-08-15", value: 4 },
    { date: "2024-08-20", value: 3 },
    { date: "2024-08-25", value: 2 },
    { date: "2024-08-30", value: 3 }
  ]
}; 